/* jshint esversion: 6 */
/* jshint ignore:start */
import { createContext, useState } from 'react';

const MyContext = createContext();

const MyProvider = ({ children }) => {

    const BaseUrl = "https://kiffadmin.biyeti.com/";
    // const BaseUrl = "http://13.203.184.66/ev/";

    // OneSignal Customer AppId 
    const OneSingalAppidCO = "d5937ebe-1cb7-4151-a047-9c3c4f89007c";

    // OneSignal Organizer AppId & Key 
    const OneSingalAppidOR = "343e0b1a-cb3a-40b9-ab99-738556a6b4af";
    const OneSingalKeyOR = "os_v2_app_gq7awgwlhjaltk4zoocvnjvuv6zt7jaeso5ujhfvx6ikfp4pmxwqyhs57m7xeo5wyqjsurxprqnilz4vp73k7sgrrtk7j25yobhal3a";

    const MapKey = "AIzaSyB_UF7HzPK2hKlLglUKMf4cQCfpsf9p39";


    const [isLoginShow, setIsLoginShow] = useState(false);
    const [isSignUpShow, setIsSignUpShow] = useState(false);
    const [isLogin, setIsLogin] = useState("");
    const [paymentRes, setPaymentRes] = useState();
    const [transactionId, setTransactionId] = useState();
    const [paymentLoad, setPaymentLod] = useState(false);
    const [isValidate, setIsValidate] = useState(false);

    const Value = {
        isLoginShow, setIsLoginShow,
        isSignUpShow, setIsSignUpShow,
        isLogin, setIsLogin,
        paymentRes, setPaymentRes,
        transactionId, setTransactionId,
        paymentLoad, setPaymentLod,
        isValidate, setIsValidate,
        OneSingalAppidCO,
        OneSingalAppidOR, OneSingalKeyOR,
        BaseUrl, MapKey
    };

    return (
        <MyContext.Provider value={Value}>
            {children}
        </MyContext.Provider>
    );
};

export { MyContext, MyProvider };
/* jshint ignore:end */
